import { takeEvery, takeLatest } from 'redux-saga/effects';
import { RESOURCE_LOOKUP_GET_RESOURCES, RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO, RESOURCE_LOOKUP_GET_REPAIR_RESOURCES } from '../actions';
import { getResourcesSaga } from './getResourcesSaga';
import { getAssigneeShopInfoSaga } from './getAssigneeShopInfoSaga';
import { getRepairResourcesSaga } from './getRepairResourcesSaga';
export function* resourceLookupRootSaga() {
    yield takeEvery(RESOURCE_LOOKUP_GET_RESOURCES, getResourcesSaga);
    yield takeEvery(RESOURCE_LOOKUP_GET_ASSIGNEE_SHOP_INFO, getAssigneeShopInfoSaga);
    yield takeLatest(RESOURCE_LOOKUP_GET_REPAIR_RESOURCES, getRepairResourcesSaga);
}
//# sourceMappingURL=resourceLookupRootSaga.js.map